module.exports = "/_next/static/images/game-2-intro-tutorial-paper-uv-5c30a6f5ca1f871281404e26556081f4.png";